module.exports = __webpack_public_path__ + "img/salam-1.96d440ff.png";